window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

import $ from 'jquery'
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import { createPinia } from 'pinia';
import router from "./router";
import { vMaska } from 'maska';
import Dropdown from 'primevue/dropdown';
import PrimeVue from 'primevue/config';
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIISoul from "./soft-ui-iisoul";
import VueSweetalert2 from "vue-sweetalert2";
import Axios from './services/axios.service';
import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';
import LoadingComponent from '@/components/LoadingComponent.vue';

window.$ = $;
window.jQuery = $;
window.Axios = new Axios();

const appInstance = createApp(App);


const MyPreset = definePreset(Aura, {
  semantic: {
      primary: {
          50: '{blue.50}',
          100: '{blue.100}',
          200: '{blue.200}',
          300: '{blue.300}',
          400: '{blue.400}',
          500: '{blue.500}',
          600: '{blue.600}',
          700: '{blue.700}',
          800: '{blue.800}',
          900: '{blue.900}',
          950: '{blue.950}',
          
      },
      
  },
});

appInstance.use(VueSweetalert2);
appInstance.use(store);
appInstance.use(createPinia());
 /* 
 appInstance.mixin({
  beforeUnmount() {
    if (window.Axios) {
      window.Axios.cancelRequest('Cancelando requisição ao sair da página');
    }
  }
}); 
*/

appInstance.use(PrimeVue, { theme: {preset: MyPreset, options: {
  darkModeSelector: '.dark-theme',
}}});
appInstance.component('DropdownSoft', Dropdown);
appInstance.component('LoadingComponent', LoadingComponent);
appInstance.use(router);
appInstance.directive('maska', vMaska);
appInstance.use(SoftUIISoul);
appInstance.mount("#app");